import React, { FC } from "react";
import { useNavigate } from "react-router";

type Props = {
  title: string;
  value: string | number;
  link?: string;
};
const InfoCard: FC<Props> = ({ title, value, link }) => {
  const navigate = useNavigate();

  return (
    <div
      className={`border border-gray-200 p-4 rounded-md w-1/5 ${
        link
          ? "cursor-pointer hover:bg-gradient-to-r from-primary to-orange-400 hover:text-white transition-colors"
          : ""
      }`}
      onClick={() => link && navigate(link)}
    >
      <h1 className={`${link ? "hover:text-gray-100" : "text-gray-600"} mb-5`}>
        {title}
      </h1>
      <p className="font-semibold text-3xl">{value}</p>
    </div>
  );
};

export default InfoCard;
